import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faSliders,
  faRocket,
  faGlobe,
  faLock,
  faLifeRing,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const steps = [
  {
    step: "01",
    title: "Choose a plan",
    desc: "Pick shared, WordPress, or VPS based on traffic, apps, and whether you need root access or managed simplicity.",
    icon: faCartShopping,
  },
  {
    step: "02",
    title: "Configure & provision",
    desc: "We set up your account, PHP version, databases, and control panel access — aligned with your CMS or framework.",
    icon: faSliders,
  },
  {
    step: "03",
    title: "Deploy or migrate",
    desc: "Upload a fresh build or we migrate from your old host: files, DB, cron jobs, and environment variables as needed.",
    icon: faRocket,
  },
  {
    step: "04",
    title: "Point your domain",
    desc: "Update DNS at your registrar (or with us), lower TTL if required, and verify propagation before cutover.",
    icon: faGlobe,
  },
  {
    step: "05",
    title: "SSL & go live",
    desc: "Issue certificates, fix mixed content, force HTTPS, and smoke-test forms, checkout, and APIs.",
    icon: faLock,
  },
  {
    step: "06",
    title: "Monitor & support",
    desc: "Ongoing backups, updates guidance, and scaling advice — from cache tuning to upgrading tiers.",
    icon: faLifeRing,
  },
];

const Process = () => {
  return (
    <section className="processV2">
      <div className="processV2-wrap">
        <header className="processV2-head">
          <span className="processV2-tag">How it works</span>
          <h2>
            From signup to a live, secure site
            <span> — a clear path at every step</span>
          </h2>
          <p>
            No mystery handoffs: you always know what happens for provisioning,
            DNS, SSL, and launch — whether you’re starting new or migrating in.
          </p>
        </header>

        <div className="processV2-grid">
          {steps.map((step) => (
            <article className="processV2-card" key={step.step}>
              <div className="processV2-top">
                <div className="processV2-icon">
                  <FontAwesomeIcon icon={step.icon} />
                </div>
                <span className="processV2-step">{step.step}</span>
              </div>

              <div className="processV2-content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
